import _ from 'lodash';
import { validateWheelInspectionComplete } from '../utils/wheelInspectionUtil';

export const REGISTRATION_TAB_LAST_INDEX = 3;

/**
 * 마지막 탭에서만 작성완료 버튼 활성화 여부 계산
 */
export function useRegistrationFormTabs({
  registrationTab,
  currentValues,
  fileItems,
}) {
  const isLastTab = registrationTab === REGISTRATION_TAB_LAST_INDEX;

  if (!isLastTab) {
    return { completeReady: false, isLastTab: false };
  }

  const wheelResult = validateWheelInspectionComplete(
    { vehicleInformation: currentValues?.vehicleInformation },
    fileItems
  );

  const vi = currentValues?.vehicleInformation || {};
  const basics =
    !!_.get(currentValues, 'licensePlateNumber') &&
    !!_.get(currentValues, 'inspector.userName') &&
    !!_.get(currentValues, 'customer.customerName') &&
    !!vi.VIN &&
    !!vi.vinRemain &&
    !!vi.displacement &&
    !!vi.maxPerson &&
    !!currentValues?.TRVL_DSTNC;

  return {
    completeReady: wheelResult.ok && basics,
    isLastTab: true,
  };
}
